import _ from 'lodash'
import type {CalcSizeType, Calculation} from '@wix/document-services-types'
import {deserializeFunction, serializeFunction} from '../utils/function'
import type {CssValue} from '../../constants'

const CALC_SIZE_TYPE: CalcSizeType = 'Calc'
const CALC_FUNCTION_NAME: string = 'calc'

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const {type, value} = val

    if (type !== CALC_SIZE_TYPE || !_.isString(value)) {
        return undefined
    }

    return serializeFunction({name: CALC_FUNCTION_NAME, args: [value]})
}

const deserialize = (rule: CssValue): Calculation | undefined => {
    const func = deserializeFunction(rule)
    if (!func) {
        return undefined
    }

    const {name, args} = func

    if (name !== CALC_FUNCTION_NAME || args.length !== 1) {
        return undefined
    }

    return {
        type: CALC_SIZE_TYPE,
        value: args[0]
    }
}

export default {
    serialize,
    deserialize
}
